<template>
  <div v-if="ticket" class="container single">
    <common-step-bar :step-number="3" :current-step="confirm ? 2 : 1" class="marginY4" />
    <div v-if="!confirm">
      <h1 class="pageTitle marginY3">購入方法の選択</h1>
      <div class="purchaseForm">
        <div class="paddingX3">
          <common-flash-message />
          <flash-message v-if="errorMessages" :messages="errorMessages" type="error" />
          <flash-message v-if="warningMessage" :message="warningMessage" type="warning" />
        </div>
        <!-- 名前入力フォーム（名前未登録の場合のみ表示） -->
        <div v-if="user.needs_name_register" class="nameInputSection marginY4">
          <h2 class="textBold textLarge marginB2">名前の入力</h2>
          <div class="purchaseCard commonCard">
            <div class="paddingX4 paddingY3">
              <UserProfileForm ref="userProfileForm" :initial-profile-data="nameForm" :age-conditions="{}" :name-only="true" />
            </div>
          </div>
        </div>
        <h2 class="textBold textLarge marginB2">申込内容</h2>
        <div class="purchaseCard">
          <div class="purchaseCard-event paddingX4 paddingY3">
            <div class="purchaseCard-event-box">
              <img :src="event.eyecatch" class="purchaseCard-event-box-eyecatch" />
              <div class="purchaseCard-event-box-block">
                <span class="textBold"
                  >{{ eventOrganizationTime }}
                  <div v-if="eventStartToday" class="purchaseCard-event-box-block-today">本日開催</div></span
                ><br />
                <span class="purchaseCard-event-box-block-area">{{ event.prefecture_name }} / {{ event.area_name }}</span>
              </div>
            </div>
            <div class="purchaseCard-event-title marginT3">{{ event.event_title }}</div>
          </div>
          <div class="purchaseCard-priceData">
            <dl ref="priceDataElement" class="priceData marginX4 marginY3">
              <div class="priceData-item paddingB2">
                <dt class="priceData-item-term">購入枚数</dt>
                <dd v-if="!ticket.original_stage_ticket_id" class="priceData-item-desc">
                  <select v-if="canSelectQuantity" v-model="model.quantity" class="commonInput" @change="onChangeQuantity">
                    <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value" :disabled="quantity.disabled">
                      {{ quantity.text }}
                    </option>
                  </select>
                  <template v-else-if="alreadyPurchasedSoloEvent">
                    <select disabled class="commonInput" style="opacity: 0.5">
                      <option>1枚</option>
                    </select>
                    <p class="marginT2" style="color: #e74c3c; font-size: 12px">
                      既にチケットを申込済です。お申込みチケットは<a :href="purchasedTicketUrl">こちら</a>。
                    </p>
                  </template>
                  <template v-else>
                    1枚
                    <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                  </template>
                </dd>
                <dd v-else class="priceData-item-desc">
                  <select v-if="canSelectQuantity" v-model="model.quantity" class="commonInput" @change="onChangeQuantity">
                    <option v-for="(quantity, index) in quantitySelectOptions" :key="index" :value="quantity.value">
                      {{ quantity.text }}
                    </option>
                  </select>
                  <template v-else-if="alreadyPurchasedSoloEvent">
                    <select disabled class="commonInput" style="opacity: 0.5">
                      <option>1枚</option>
                    </select>
                    <p class="marginT2" style="color: #e74c3c; font-size: 12px">
                      既にチケットを申込済です。お申込みチケットは<a :href="purchasedTicketUrl">こちら</a>。
                    </p>
                  </template>
                  <template v-else>
                    1枚
                    <p v-if="isMarriageMemberEvent && !isMdgMemberPartyEvent">このイベントは1枚しか購入できません</p>
                  </template>
                </dd>
                <div v-show="displayTooltip && needDisplayTooltip" class="priceData-item-tooltip">
                  <div class="priceData-item-tooltip-inner">{{ tooltipText }}</div>
                </div>
              </div>

              <div v-if="hasGroupDiscount" class="priceData-item paddingY2">
                <div></div>
                <div class="priceData-item-group-discount paddingY2">複数枚購入で割引あり！</div>
              </div>
              <div class="priceData-item paddingY2">
                <dt class="priceData-item-term">{{ ticketName }}</dt>
                <dd class="priceData-item-desc">
                  <template v-if="!ticket.original_stage_ticket_id">
                    {{ ticketPrice }}
                  </template>
                  <template v-else>
                    <span class="price">{{ ticketPrice }}</span>
                    <span class="originPrice">{{ originStageTicketPrice }}</span>
                  </template>
                </dd>
              </div>
              <div v-if="isSelectedGroupDiscount" class="priceData-item paddingY2">
                <dt class="priceData-item-term">小計</dt>
                <dd class="priceData-item-desc">{{ numberToCurrency(totalOriginStageTicketPrice) }}</dd>
              </div>
              <div v-if="event.goto_campaign_event" class="priceData-item paddingY2">
                <dt class="priceData-item-term">Go Toイベント割引</dt>
                <dd class="priceData-item-desc">{{ gotoEventTicketDiscount }}</dd>
              </div>
              <div v-if="ticket.mens_pass_discount_price && !canBuyWithMenspass" class="priceData-item paddingY2">
                <dt class="priceData-item-term">割引(メンズパス)</dt>
                <dd class="priceData-item-desc">- {{ numberToCurrency(ticket.mens_pass_discount_price) }}</dd>
              </div>
              <div v-if="model.include_repeat_discount" class="priceData-item paddingY2">
                <dt class="priceData-item-term">500円OFFリピート券2枚</dt>
                <dd class="priceData-item-desc">{{ numberToCurrency(500) }}</dd>
              </div>
              <div v-if="model.use_repeat_discount" class="priceData-item paddingY2 priceData-discountAmount">
                <dt class="priceData-item-term">リピート券割引</dt>
                <dd class="priceData-item-desc">-{{ numberToCurrency(500) }}</dd>
              </div>
              <transition name="fade">
                <div v-if="discountAmount" class="priceData-item paddingY2 priceData-discountAmount">
                  <dt class="priceData-item-term">割引</dt>
                  <dd class="priceData-item-desc">-{{ numberToCurrency(discountAmount) }}</dd>
                </div>
              </transition>
              <div v-if="isSelectedGroupDiscount" class="priceData-item priceData-discountAmount paddingY2">
                <dt class="priceData-item-term">グループ割引</dt>
                <dd class="priceData-item-desc">-{{ numberToCurrency(groupDiscountAmount) }}</dd>
              </div>
              <div class="priceData-item paddingY2">
                <dt class="priceData-item-term">合計</dt>
                <dd class="priceData-item-desc">
                  <template v-if="!ticket.original_stage_ticket_id && !isSelectedGroupDiscount">
                    {{ numberToCurrency(ticketTotalPrice) }}
                  </template>
                  <template v-else>
                    <span class="price">{{ numberToCurrency(ticketTotalPriceWithGroupDiscount) }}</span>
                    <span class="originPrice">{{ numberToCurrency(totalOriginStageTicketPrice) }}</span>
                  </template>
                </dd>
              </div>
            </dl>
          </div>
        </div>
        <CouponForm v-if="displayCouponFeature" v-model:couponCode="model.coupon_code" @apply-coupon="applyCouponCode" />

        <!-- 回数券オプション -->
        <RepeatDiscountOption v-model="model.include_repeat_discount" :should-show="shouldShowRepeatDiscountOption" />

        <!-- 回数券使用セクション -->
        <RepeatDiscountUsage
          v-if="user.repeat_discounts && user.repeat_discounts.length > 0"
          v-model="model.use_repeat_discount"
          :user-repeat-discounts="user.repeat_discounts"
          :ticket-price="ticket.price"
        />

        <CustomQuestion
          v-if="event.custom_question1 || event.custom_question2"
          v-model:first-answer="model.custom_question_answer1"
          v-model:second-answer="model.custom_question_answer2"
          :first-question="event.custom_question1"
          :second-question="event.custom_question2"
        />
        <h2 class="textBold textLarge marginB2 marginT4">お支払い方法</h2>
        <div class="purchaseCard">
          <!-- 無料チケットの場合 -->
          <div v-if="isFreeTicket" class="paymentType">
            <input id="free" v-model="model.payment_method" class="paymentType-input" value="free" type="radio" />
            <label class="paymentType-label" for="free">
              <span class="paymentType-label-radio" />
              無料チケット
            </label>
          </div>
          <!-- 通常のAmazon Pay -->
          <amazon-pay-change-payment v-else />
        </div>
        <TotalPrice
          :event="event"
          :final-actual-price="ticketTotalPriceWithGroupDiscount"
          :model-quantity="model.quantity"
          :ticket-total-price-with-group-discount="ticketTotalPriceWithGroupDiscount"
          :can-go-to-next-page="!disableNextButton"
          :is-marriage-member-event="isMarriageMemberEvent"
          :is-provide-info-event="isProvideInfoEvent"
          :agree-provide-info="agreeProvideInfo"
          submit-text="次へ"
          :processing="processing"
          @update-agree-provide-info="onUpdateAgreeProvideInfo"
          @to-next-page="toPurchaseConfirm"
        />
        <button class="cancelLink marginT4" @click="browserBackToEventDetail">戻る</button>
      </div>
    </div>
    <purchase-confirmation
      v-else
      :model="model"
      :ticket="ticket"
      :event="event"
      :user="user"
      :name-form="nameForm"
      @go-back="backToNewPage"
      @confirm-purchase="handleConfirmPurchase"
    />

    <!-- 回数券モーダル -->
    <RepeatDiscountModal
      :should-show-modal="shouldShowRepeatDiscountModal()"
      @close-modal="closeRepeatDiscountModal"
      @purchase-with-repeat-discount="handlePurchaseWithRepeatDiscount"
      @purchase-without-repeat-discount="handlePurchaseWithoutRepeatDiscount"
    />
  </div>
</template>

<script>
import { numberToCurrency, timeConverter } from '@/utils/converter'
import { scrollTo, scrollToTop } from '@/utils/ScrollTo'
import PurchaseMixin from '@/utils/mixins/PurchaseMixin'
import BrowserBackMixin from '@/utils/mixins/BrowserBackMixin'
import GTM from '@/utils/tracking/gtm'
import CriteoGtmDatalayer from '@/utils/CriteoGtmDatalayer'
import BrowserStorage from '@/utils/BrowserStorage'
import GlobalCookie from '@/utils/GlobalCookie'
import Cookies from 'mj-cookie'
import { useMainStore } from '@/store'
import {
  COOKIE_AMAZON_CHECKOUT_SESSION_ID,
  NEED_RELOGIN_ERROR_CODES,
  CHECKOUT_SESSION_ID_ERROR_CODE,
  COOKIE_AMAZON_PURCHASE_QUANTITY
} from '@/utils/constants/amazonPay'
import { NEED_OTP_CONFIRMATION_ERROR_CODE } from '@/utils/constants/commons'
import { useNuxtApp } from '#app'
import { callWithNuxt } from 'nuxt/app'
import { reactive } from 'vue'
import useABTestV2 from '@/utils/abtest/useABTestV2'
import { REPEAT_DISCOUNT_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import { sendRepeatDiscountViewEvent, sendFirstEventPurchaseEvent, sendMultipleEventPurchaseEvent } from '@/utils/abtest/repeatDiscountGAEvent'
import { PENDING_NAME_STORAGE_KEY } from '@/utils/constants/purchase'
import { isSoloParticipationEvent, alreadyPurchasedSoloEventMessage, purchasedTicketPath } from '@/utils/purchaseValidation'

const FlashMessage = defineAsyncComponent(() => import('@/components/FlashMessage.vue'))
const CommonFlashMessage = defineAsyncComponent(() => import('@/components/CommonFlashMessage.vue'))
const CommonStepBar = defineAsyncComponent(() => import('@/components/CommonStepBar.vue'))
const AmazonPayChangePayment = defineAsyncComponent(() => import('@/components/purchase/AmazonPayChangePayment.vue'))
const CouponForm = defineAsyncComponent(() => import('@/components/purchase/CouponForm.vue'))
const CustomQuestion = defineAsyncComponent(() => import('@/components/purchase/CustomQuestion.vue'))
const TotalPrice = defineAsyncComponent(() => import('@/components/purchase/TotalPrice.vue'))
const RepeatDiscountUsage = defineAsyncComponent(() => import('@/components/purchase/RepeatDiscountUsage.vue'))
const RepeatDiscountOption = defineAsyncComponent(() => import('@/components/purchase/RepeatDiscountOption.vue'))
const RepeatDiscountModal = defineAsyncComponent(() => import('@/components/modals/RepeatDiscountModal.vue'))
const PurchaseConfirmation = defineAsyncComponent(() => import('@/components/purchase/PurchaseConfirmation.vue'))
const UserProfileForm = defineAsyncComponent(() => import('@/components/purchase/UserProfileForm.vue'))

const DEFAULT_COMPONENT_DATA = {
  useCoupon: false,
  couponCode: null,
  displayTooltip: false,
  processing: false,
  confirm: false
}
export default {
  components: {
    FlashMessage,
    CommonFlashMessage,
    CommonStepBar,
    AmazonPayChangePayment,
    CouponForm,
    CustomQuestion,
    TotalPrice,
    RepeatDiscountUsage,
    RepeatDiscountOption,
    RepeatDiscountModal,
    PurchaseConfirmation,
    UserProfileForm
  },
  mixins: [PurchaseMixin, BrowserBackMixin],
  async setup() {
    const { sendOnPaymentPageClick } = usePaymentFlowABTest()

    const app = useNuxtApp()
    const route = useRoute()
    const store = useMainStore()
    const params = route.params
    const query = route.query
    const globalCookie = new GlobalCookie(store)
    const checkoutSessionId = globalCookie.get(COOKIE_AMAZON_CHECKOUT_SESSION_ID)
    const cookiePurchaseQuantity = globalCookie.get(COOKIE_AMAZON_PURCHASE_QUANTITY)
    const requests = []
    const payload = {
      checkoutSessionId: checkoutSessionId,
      eventCode: params.code,
      ticketId: params.ticket_id,
      quantity: query.quantity || cookiePurchaseQuantity
    }
    definePageMeta({
      middleware: [
        function (to) {
          const store = useMainStore()
          if (!store.$state.auth_info) {
            navigateTo(`/events/${to.params.code}/tickets/${to.params.ticket_id}/amazon_purchases/guest_new/`)
          }
        }
      ],
      layout: 'simple'
    })
    const criteoGtmDatalayer = new CriteoGtmDatalayer(store)
    if (query['purchase[coupon_code]']) {
      payload.couponCode = query['purchase[coupon_code]']
      payload.applyCoupon = true
    }
    if (query['purchase[quantity]']) payload.quantity = query['purchase[quantity]']
    const purchaseRequest = store.dispatch('purchaseNew', payload).then(response => {
      const resData = response.data
      if (resData.error_code && resData.error_code === 'ResourceNotFound') {
        const redirectPath = `/events/${payload.eventCode}/tickets/${payload.ticketId}/purchase_options/?quantity=${query.quantity || 1}`
        return callWithNuxt(app, () => navigateTo({ path: redirectPath, query: { error_code: resData.error_code } }))
      }
      if (resData.redirect_path) return callWithNuxt(app, () => navigateTo(resData.redirect_path))
      const quantity = resData.ticket.quantity || query.quantity || 1
      const mensPassDiscountPrice = Number(!resData.can_buy_with_mens_pass && resData.ticket.mens_pass_discount_price) || 0
      const price = resData.event.goto_campaign_event ? resData.ticket.goto_campaign_event_ticket_price : resData.ticket.price
      const totalPrice = price * quantity - mensPassDiscountPrice - resData.ticket.coupon_discount_price
      if (
        resData.event.konkatsu_freepass ||
        resData.event.men_pass ||
        resData.ticket.can_user_purchase_with_already_have_konkatsu_freepass ||
        totalPrice <= 0
      ) {
        return callWithNuxt(app, () => navigateTo({ path: `/events/${params.code}/tickets/${params.ticket_id}/purchases/new/`, query: query }))
      }
      const data = {
        errorMessages: resData.error_messages || null,
        canBuyWithMenspass: resData.can_buy_with_mens_pass,
        ticket: resData.ticket,
        event: resData.event,
        user: resData.user,
        alreadyBoughtWithMensPass: resData.already_purchased_with_mens_pass,
        soloParticipationOnly: isSoloParticipationEvent(resData.event.event_title),
        alreadyPurchasedSoloEvent: isSoloParticipationEvent(resData.event.event_title) && (resData.already_purchased_solo_event || false),
        alreadyPurchasedEventPurchaseId: resData.already_purchased_event_purchase_id || null
      }
      if (payload.applyCoupon && !data.errorMessages) {
        data.useCoupon = true
        data.couponCode = payload.couponCode
      }

      data.warningMessage = data.alreadyBoughtWithMensPass ? 'メンズパスで購入済み' : ''
      if (data.alreadyPurchasedSoloEvent) {
        const soloMessage = alreadyPurchasedSoloEventMessage(data.alreadyPurchasedEventPurchaseId)
        data.errorMessages = data.errorMessages ? [...data.errorMessages, soloMessage] : [soloMessage]
      }
      return { ...DEFAULT_COMPONENT_DATA, ...data }
    })

    requests.push(purchaseRequest)
    requests.push(criteoGtmDatalayer.fetchData())

    // A/Bテストの実行
    const repeatDiscountABTest = useABTestV2(REPEAT_DISCOUNT_AB_TEST_CONFIG)

    try {
      const [mainContents, gtmContents] = await Promise.all(requests)
      return reactive({ ...mainContents, ...gtmContents, repeatDiscountABTest, sendOnPaymentPageClick })
    } catch (e) {
      const errorCode = parseInt(e.response && e.response.status)
      await app.$error(errorCode)
    }
  },
  data() {
    return {
      ...DEFAULT_COMPONENT_DATA,
      model: {
        quantity: null,
        using_point: 0,
        coupon_code: null,
        verified_coupon_code: null,
        payment_method: 'amazon_pay',
        ticket_type: 'normal',
        custom_question_answer1: null,
        custom_question_answer2: null,
        include_repeat_discount: false,
        use_repeat_discount: false
      },
      purchaseProductsKey: 'criteo_purchase_products',
      agreeProvideInfo: false,
      hasVisitedConfirmation: false,
      nameForm: {
        family_name: '',
        given_name: ''
      },
      pendingNameStorageKey: PENDING_NAME_STORAGE_KEY
    }
  },
  computed: {
    ticketName() {
      return `${this.ticket.name}チケット`
    },
    discountAmount() {
      if (!this.ticket.coupon_discount_price || this.ticket.coupon_discount_price <= 0) return null
      return this.ticket.coupon_discount_price
    },
    groupDiscountAmount() {
      if (!this.ticket.group_discounts || this.model.quantity === 1) return 0
      const genderGroupDiscounts = this.ticket.group_discounts.filter(d => d.gender === this.myGender)
      const discountData = genderGroupDiscounts.find(d => d.applicable_person_count === this.model.quantity)
      return discountData.discount_price
    },
    myGender() {
      return this.$store.myGender
    },
    ticketPriceAfterMenspassDiscount() {
      const price = this.purchasePrice - Number(this.ticket.mens_pass_discount_price)
      return price < 0 ? 0 : price
    },
    ticketRegularPrice() {
      return this.purchasePrice * this.model.quantity
    },
    ticketTotalPriceBeforeUsePoint() {
      if (this.ticket.mens_pass_discount_price && !this.canBuyWithMenspass) {
        const totalPrice = this.ticketRegularPrice - Number(this.ticket.mens_pass_discount_price) - this.ticket.coupon_discount_price
        return totalPrice > 0 ? totalPrice : 0
      }
      return this.ticketRegularPrice - this.ticket.coupon_discount_price
    },
    ticketTotalPrice() {
      let totalPrice = this.ticketTotalPriceBeforeUsePoint - this.model.using_point
      // 回数券が選択されている場合は500円を追加
      if (this.model.include_repeat_discount) {
        totalPrice += 500
      }
      // 回数券利用時は500円割引
      if (this.model.use_repeat_discount) {
        totalPrice -= 500
      }
      return totalPrice > 0 ? totalPrice : 0
    },
    ticketTotalPriceWithGroupDiscount() {
      return this.ticketTotalPrice - this.groupDiscountAmount
    },
    totalOriginStageTicketPrice() {
      const ticketPrice = this.ticket.original_stage_ticket_price || this.ticket.price
      return ticketPrice * this.model.quantity
    },
    isFreeTicket() {
      return Number(this.ticketTotalPrice) === 0 && Number(this.model.quantity) !== 0
    },
    eventOrganizationTime() {
      if (this.event.event_type === 'bar_gourmet') {
        const startAt = timeConverter(this.event.start_at).fullDate
        const endAt = timeConverter(this.event.end_at).fullDate
        return startAt === endAt ? `${startAt}〜` : `${startAt}〜${endAt}`
      }
      const startDate = timeConverter(this.event.start_at).fullDateWithoutYear
      return `${startDate} `
    },
    eventStartToday() {
      if (this.event.event_type === 'bar_gourmet') return false
      const today = timeConverter().dateTime
      return today.isSameOrAfter(this.event.start_at, 'day') && today.isSameOrBefore(this.event.end_at, 'day')
    },
    quantitySelectOptions() {
      const maxQuantity = this.ticket.selectable_quantity_max
      const list = []

      if (this.soloParticipationOnly) {
        list.push({
          value: 1,
          text: `1枚 ${1 > this.ticket.available_quantity ? '✖' : '〇'}`,
          disabled: 1 > this.ticket.available_quantity
        })
        return list
      }

      for (let i = 1; i <= maxQuantity; i++) {
        const unavailableText = this.ticket.original_stage_ticket_id ? '△ 通常チケット価格在庫あり' : '✖'
        list.push({
          value: i,
          text: `${i}枚 ${i > this.ticket.available_quantity ? `${unavailableText}` : '〇'}`,
          disabled: i > this.ticket.available_quantity
        })
      }
      return list
    },
    canSelectQuantity() {
      if (this.soloParticipationOnly) return false
      return (
        (this.ticket.quantity_changeable || this.ticket.original_stage_ticket_id) &&
        (!this.isMarriageMemberEvent || this.isMdgMemberPartyEvent) &&
        !this.isOnlineEvent
      )
    },
    displayCouponFeature() {
      return this.ticket.can_use_coupon_feature && !this.ticket.mens_pass_ticket_plan_monthly_auto_renew
    },
    needDisplayTooltip() {
      if (this.soloParticipationOnly) return true
      return (!this.ticket.quantity_changeable && !this.ticket.original_stage_ticket_id) || this.model.quantity > 1
    },
    tooltipText() {
      if (this.soloParticipationOnly) return '一人参加限定イベントのため、1枚のみ購入可能です'
      if (!this.ticket.quantity_changeable && !this.ticket.original_stage_ticket_id) return 'チケット残数が1枚のため複数購入することができません'
      if (this.model.quantity > 1) return 'まとめてご購入いただいたうち、一部のチケットのキャンセルはできません'
      return ''
    },
    localStorage() {
      return new BrowserStorage('localStorage')
    },
    isMarriageMemberEvent() {
      return this.event.marriage_member_event
    },
    isMdgMemberPartyEvent() {
      return this.event.mdg_member_party_event
    },
    purchasedTicketUrl() {
      return purchasedTicketPath(this.alreadyPurchasedEventPurchaseId)
    },
    disableNextButton() {
      if (this.alreadyPurchasedSoloEvent) return true
      return (this.isMarriageMemberEvent || this.event.provide_user_info_event) && !this.agreeProvideInfo
    },
    isOnlineEvent() {
      return this.event && this.event.online_event_type !== 'offline'
    },
    hasGroupDiscount() {
      return this.ticket.group_discounts
    },
    isSelectedGroupDiscount() {
      return this.hasGroupDiscount && this.model.quantity > 1
    },
    // 回数券関連のcomputed
    shouldShowRepeatDiscountOption() {
      return this.$store.isLoggedIn && this.user?.eligible_for_repeat_discount && this.repeatDiscountABTest.isBPattern
    }
  },
  watch: {
    isFreeTicket(_to) {
      if (this.isFreeTicket) {
        this.model.payment_method = 'free'
      } else {
        this.model.payment_method = 'amazon_pay'
      }
    }
  },
  created() {
    if (!this.ticket) return
    this.initModel()
  },
  mounted() {
    this.showAndHideTooltip()
    this.pushGtmData()

    // Send AB test payment page GA event
    this.sendOnPaymentPageClick()

    // 回数券GA追跡
    if (this.$store.isLoggedIn && this.user?.eligible_for_repeat_discount) {
      sendRepeatDiscountViewEvent(this.$store, REPEAT_DISCOUNT_AB_TEST_CONFIG)
    }
  },
  methods: {
    numberToCurrency,
    restoreNameFromStorage() {
      if (import.meta.server || !this.user.needs_name_register) return
      const stored = this.localStorage.getItem(this.pendingNameStorageKey)
      if (!stored) return
      try {
        const parsed = JSON.parse(stored)
        this.nameForm.family_name = parsed.family_name || ''
        this.nameForm.given_name = parsed.given_name || ''
      } catch (e) {
        // ignore parse errors
      } finally {
        this.localStorage.removeItem(this.pendingNameStorageKey)
      }
    },
    initModel() {
      this.model.quantity = this.ticket.quantity || this.$route.query.quantity || 1
      if (this.couponCode) {
        this.model.coupon_code = this.couponCode
      }
      this.restoreNameFromStorage()
    },
    onChangeQuantity(e) {
      e.preventDefault()
      if (this.model.quantity > this.ticket.available_quantity && this.ticket.original_stage_ticket_id) {
        const payload = { ticket: this.ticket }
        this.$store.MODAL({ name: 'StageTicketWarningModal', payload })
        this.model.quantity =
          this.ticket.available_quantity > this.ticket.selectable_quantity_max ? this.ticket.selectable_quantity_max : this.ticket.available_quantity
        this.fetchNewTicket()
      } else {
        this.fetchNewTicket()
        this.$router.push({ path: this.$route.path, query: { quantity: this.model.quantity } })
        if (this.model.quantity > 1) {
          this.showAndHideTooltip()
        }
      }
    },
    applyCouponCode(e) {
      e.preventDefault()
      if (!this.model.coupon_code) {
        this.setErrorMessages('クーポンが適用されませんでした。クーポンコードが入力されていません')
      } else {
        this.fetchNewTicket()
      }
    },
    setErrorMessages(messages) {
      if (messages instanceof Array) {
        this.errorMessages = messages
      } else {
        this.errorMessages = [messages]
      }
      scrollToTop()
    },
    fetchNewTicket() {
      this.errorMessages = null
      const checkoutSessionId = Cookies.get(COOKIE_AMAZON_CHECKOUT_SESSION_ID)
      const payload = {
        checkoutSessionId,
        eventCode: this.$route.params.code,
        ticketId: this.$route.params.ticket_id,
        quantity: this.model.quantity,
        usingPoint: this.model.using_point,
        ticketType: this.model.ticket_type
      }
      if (this.model.coupon_code) {
        payload.applyCoupon = true
        payload.couponCode = this.model.coupon_code
        payload.firstVisitGuestCouponSessionId = Cookies.get('first_visit_guest_coupon_session_id')
      }
      return this.$store
        .dispatch('purchaseNew', payload)
        .then(res => {
          this.ticket = res.data.ticket
          if (payload.applyCoupon) {
            if (res.data.error_messages) {
              this.model.verified_coupon_code = null
              this.setErrorMessages(`クーポンが適用されませんでした。${res.data.error_messages}`)
            } else {
              this.model.verified_coupon_code = payload.couponCode
              scrollTo(this.$refs.priceDataElement)
            }
          } else if (res.data.error_messages) {
            this.setErrorMessages(res.data.error_messages)
          }
        })
        .catch(() => {
          this.setErrorMessages(this.$useI18('errors.default'))
        })
    },
    async toPurchaseConfirm(e) {
      if (e) e.preventDefault()
      if (this.processing || (this.isMarriageMemberEvent && !this.agreeProvideInfo)) return
      this.processing = true

      // 名前入力が必要な場合のバリデーション
      if (this.user.needs_name_register) {
        const userProfileForm = this.$refs.userProfileForm
        if (userProfileForm) {
          const profile = userProfileForm.profile
          this.nameForm.family_name = profile.family_name
          this.nameForm.given_name = profile.given_name
          const errorMessages = userProfileForm.validateUserProfile()
          if (errorMessages.length !== 0) {
            this.setErrorMessages('お名前を正しく入力してください')
            this.processing = false
            return
          }
        }
      }

      if (this.model.coupon_code || this.model.verified_coupon_code) {
        if (!this.model.coupon_code) this.model.coupon_code = this.model.verified_coupon_code
        await this.fetchNewTicket()
        if (this.errorMessages) {
          this.processing = false
          return
        }
      }

      // model.quantityが正しく設定されているかを確認・設定
      if (!this.model.quantity || this.model.quantity === null) {
        this.model.quantity = this.ticket.quantity || this.$route.query.quantity || 1
      }

      this.confirm = true
      this.processing = false
    },
    async sendPurchaseRequest() {
      this.pushGtmData()
      this.processing = true

      // GA購入イベント送信
      this.sendPurchaseGAEvent()

      if (this.$store.$state.flash_message) this.$store.FLASH_MESSAGE(null)

      if (this.isFreeTicket) this.model.payment_method = 'free'
      const postData = { ...this.model }
      const globalCookie = new GlobalCookie(this.$store)
      postData.checkout_session_id = globalCookie.get(COOKIE_AMAZON_CHECKOUT_SESSION_ID)

      if (this.model.coupon_code) {
        postData.first_visit_guest_coupon_session_id = Cookies.get('first_visit_guest_coupon_session_id')
      }
      if (this.user.needs_name_register && this.nameForm) {
        postData.family_name = this.nameForm.family_name
        postData.given_name = this.nameForm.given_name
      }

      const payload = { eventCode: this.$route.params.code, ticketId: this.$route.params.ticket_id, postData }
      this.$store
        .dispatch('postPurchase', payload)
        .then(data => {
          if (data.error_code) {
            if (NEED_RELOGIN_ERROR_CODES.includes(data.error_code)) {
              this.redirectWithFlashMessage(this.$useI18('errors.amazon_payment')[data.error_code])
            } else if (data.error_code === NEED_OTP_CONFIRMATION_ERROR_CODE) {
              this.resetStates()
            } else if (data.error_code === CHECKOUT_SESSION_ID_ERROR_CODE) {
              this.resetStates()
              this.redirectWithFlashMessage(this.$useI18('errors.default'))
            } else {
              this.resetStates()
              this.setErrorMessages(
                this.$useI18('errors.amazon_payment')[data.error_code] || this.$useI18(`errors.${data.error_code}`) || this.$useI18('errors.default')
              )
            }
          } else if (data.redirect_path) {
            this.postRegisterAmazonAccount()
            window.location.href = data.redirect_path
          }
        })
        .catch(e => {
          const errorStatus = parseInt(e.response && e.response.status)
          if (errorStatus === 502) {
            if (this.$bugsnag) {
              const errorMessage = `Amazon Pay CloudFront Time Out Error: [user_id = ${this.$store.$state.my_profile.id}, ticket_id = ${this.$route.params.ticket_id}, event_code: ${this.$route.params.code}]`
              this.$bugsnag.notify(errorMessage)
            }
            const redirectPath = `/events/${this.$route.params.code}/`
            this.$store.FLASH_MESSAGE({
              type: 'error',
              target_path: redirectPath,
              message: this.$useI18('errors.amazon_payment.purchase_timeout_cloudfront_notice')
            })
            return this.$router.push(redirectPath)
          }
          this.resetStates()
          this.redirectWithFlashMessage(this.$useI18('errors.default'))
        })
    },
    // 確認画面からの購入確定処理
    async handleConfirmPurchase() {
      if (this.processing) return
      await this.sendPurchaseRequest()
    },
    redirectWithFlashMessage(message) {
      const redirectPath = `/events/${this.$route.params.code}/tickets/${this.$route.params.ticket_id}/purchase_options/?quantity=${this.$route.query.quantity || 1}`
      this.$store.FLASH_MESSAGE({ type: 'error', target_path: redirectPath, message })
      this.$router.push(redirectPath)
    },
    postRegisterAmazonAccount() {
      const payload = { checkout_session_id: Cookies.get(COOKIE_AMAZON_CHECKOUT_SESSION_ID) }
      return this.$store.dispatch('postRegisterAmazonAccount', payload)
    },
    openRequirementModal(e) {
      e.preventDefault()
      const payload = {
        defaultRequirementTitle: this.event.default_requirement_title,
        maleAgeRequirement: this.event.male_age_requirement_text,
        femaleAgeRequirement: this.event.female_age_requirement_text,
        requirements: this.event.requirements
      }
      this.$store.MODAL({ name: 'PurchaseRequirementModal', payload })
    },
    showAndHideTooltip() {
      this.displayTooltip = true
      setTimeout(() => {
        this.displayTooltip = false
      }, 5000)
    },
    pushGtmData() {
      const gtm = new GTM(this.$route, this.$store)
      GTM.pushData(gtm.defaultData)
      const productList = [{ id: `${this.event.id}`, price: `${this.purchasePrice}`, quantity: `${this.model.quantity}` }]
      GTM.pushData({
        PageType: 'Basketpage',
        HashedEmail: this.gtmDatalayer.hashed_email,
        ProductBasketProducts: productList,
        Ui_userlv: this.gtmDatalayer.ui_userlv
      })
      GTM.trackingPageView(this.$route)
    },
    onUpdateAgreeProvideInfo(value) {
      this.agreeProvideInfo = value
    },
    backToNewPage(data) {
      this.resetStates()
      if (data?.needDisableCardEasyPayment) {
        this.user.active_setup_intent_exists = false
      }
      if (data?.errorMessage) {
        this.setErrorMessages(data.errorMessage)
      }
    },

    // 状態をリセットする共通メソッド（Amazon Pay用）
    resetStates() {
      this.confirm = false
      this.agreeProvideInfo = false
      this.processing = false
    },

    shouldShowRepeatDiscountModal() {
      // 基本条件：ログイン済み && 回数券対象ユーザー && 確認画面に一度も進んでいない
      if (!this.$store.isLoggedIn || !this.user?.eligible_for_repeat_discount || this.hasVisitedConfirmation) {
        return false
      }

      // A/Bテストの結果でBパターン（テストグループ）の場合のみモーダル表示
      if (this.repeatDiscountABTest.isBPattern) {
        return true
      } else if (this.repeatDiscountABTest.isAPattern) {
        return false
      }

      return false
    },

    closeRepeatDiscountModal() {
      this.model.include_repeat_discount = false
    },

    handlePurchaseWithRepeatDiscount() {
      this.model.include_repeat_discount = true
    },

    handlePurchaseWithoutRepeatDiscount() {
      this.model.include_repeat_discount = false
    },

    // GA購入イベント送信
    sendPurchaseGAEvent() {
      // APIレスポンスから購入回数を取得
      const purchaseCount = this.user?.purchase_count ?? 0

      if (purchaseCount === 0) {
        // 初回購入
        sendFirstEventPurchaseEvent(this.$store, REPEAT_DISCOUNT_AB_TEST_CONFIG, this.model.include_repeat_discount)
      } else {
        // リピート購入
        const options = {
          isGuestPurchase: false,
          hasGroupDiscount: this.isSelectedGroupDiscount
        }
        sendMultipleEventPurchaseEvent(this.$store, REPEAT_DISCOUNT_AB_TEST_CONFIG, purchaseCount + 1, this.model, options)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.purchaseButton {
  text-align: center;
  padding: 1rem 0;
  cursor: pointer;
  &.processing {
    opacity: 0.6;
    pointer-events: none;
  }
}

.paymentType {
  &:not(:last-child) {
    border-bottom: 1px solid $gray-c6;
  }
  position: relative;
  &-label {
    font-weight: bold;
    color: $gray-80;
    @include flex;
    justify-content: flex-start;
    padding: 1rem;
    margin: 0.8rem 0;
    transition: 0.2s;
    &-radio {
      min-width: 11px;
      height: 11px;
      margin: auto 1.2rem auto 0.6rem;
      background: $white;
      box-shadow: 0 0 0 4px $black-01;
      border-radius: 10px;
      transition: 0.2s;
    }
  }
  &-input {
    display: none;
    &:checked + .paymentType-label {
      color: $black-1a;
      .paymentType-label-radio {
        background: $positive-green-light;
        box-shadow: 0 0 0 4px $positive-green-dark;
      }
    }
  }
}

.priceData {
  &-tpInput {
    width: 108px;
    text-align: right;
  }
  &-item {
    @include flex;
    position: relative;
    justify-content: space-between;
    border-bottom: 1px solid $gray-c6;
    font-size: 1.2rem;
    color: $gray-55;
    &-note {
      padding: 8px;
      font-size: 1rem;
    }
    &-desc {
      text-align: right;
      select {
        color: $black-1a;
        max-width: 100px;
        height: 32px;
        font-size: 1.4rem;
      }
      .price {
        font-size: 1.6rem;
        color: $pink-thin;
        font-weight: 900;
      }
      .originPrice {
        padding-right: 5px;
        text-decoration: line-through;
      }
    }
    &-tooltip {
      position: absolute;
      width: 85%;
      bottom: 50px;
      right: 0;
      padding: 0.8rem 1rem 0.6rem;
      border-radius: 3px;
      background-color: $gray-55;
      color: $white;
      box-shadow: 0 3px 6px 0 rgba($black, 0.3);
      z-index: 1;
      font-size: 1.4rem;
      @media screen and (min-width: 960px) {
        width: 35%;
      }
      &::before,
      &::after {
        display: block;
        position: absolute;
        background-color: $gray-55;
        content: '';
      }
      &::before {
        right: 50px;
        bottom: -8px;
        width: 24px;
        height: 24px;
        transform: rotate(45deg);
        border-radius: 3px;
        box-shadow: 0 3px 6px 0 rgba($black, 0.3);
        z-index: 2;
      }
      &::after {
        right: 42px;
        bottom: 0;
        width: 40px;
        height: 20px;
        z-index: 3;
      }
      &-inner {
        position: relative;
        z-index: 10;
      }
    }
    &-group-discount {
      width: fit-content;
      padding: 2px;
      border-radius: 2px;
      background: $pink-thin;
      font-size: 1rem;
      font-weight: 700;
      text-align: right;
      color: $white;
    }
  }
}

.cancelLink {
  font-size: 1.2rem;
  text-decoration: none;
  color: $gray-55;
  border: none;
  background: none;
  cursor: pointer;
}

.fade-enter {
  &-from {
    opacity: 0;
    background-color: $foundation-success-light;
  }
  &-active {
    transition:
      opacity 0.4s linear,
      background-color 1s linear;
  }
  &-to {
    background-color: $white;
  }
}

.pageTitle {
  border-bottom: 2px solid $gray-c6;
  font-size: 1.8rem;
  text-align: center;
}

.purchaseCard {
  border: 1px solid $gray-c6;
  border-radius: 3px;
  box-shadow: 0 3px 6px 0 rgba($black, 0.16);
  &-tpLogo {
    display: flex;
    align-items: center;
    &-text {
      font-size: 16px;
      color: $black-1a;
      font-weight: bold;
    }
  }
  &-tpPoint {
    position: absolute;
    right: 20px;
    color: $black-1a;
    font-weight: bold;
  }
  &-event {
    position: relative;
    font-size: 1.2rem;
    &-box {
      display: flex;
      align-items: center;
      box-sizing: border-box;
      font-size: 1.6rem;
      font-weight: bold;
      &-eyecatch {
        max-height: 50px;
        display: inline-block;
      }
      &-block {
        display: inline-block;
        padding-left: 10px;
        &-today {
          display: inline-block;
          padding: 2px 5px 0;
          border: 1px solid #ea2e4b;
          color: #ea2e4b;
          font-size: 1rem;
        }
        &-area {
          font-size: 1rem;
        }
      }
    }
    &-title {
      font-weight: bold;
      color: $gray-55;
    }
  }
  &-priceData {
    font-size: 1.2rem;
    border-top: 1px solid $gray-c6;
    font-weight: bold;
  }
}

.purchaseForm {
  margin: 15px;
}
</style>
